module.exports = __webpack_public_path__ + "img/rel.b5c729f4.jpg";